/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ResourceTaskConsumptionTriggerType {
    Base = '0',
    Stepped = 2,
    OutOfRange = 3,
    LookBack = 4,
}
